import React from 'react';
import styled from 'styled-components';

import lang from '../language/Eng_eng.json';

const Footer = styled.footer`
  padding: 30px 10%;
  background-color: #F3EFE6;
  border-top: 1px solid #BCA18D;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 768px) {
    justify-content: center;
    padding: 20px 5%;
  }
`;

const FooterText = styled.p`
  font-family: 'EB Garamond', serif;
  font-size: 0.8rem;
  color: #5C4033;
  opacity: 0.7;
  letter-spacing: 0.05rem;
  text-transform: uppercase;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    text-align: center;
  }
`;

const Bottom_Menu: React.FC = () => {
  return (
    <Footer>
      <FooterText>{lang.footer.copyright}</FooterText>
    </Footer>
  );
};

export default Bottom_Menu;
